import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SettingsPage from './pages/SettingsPage';

export const SettingsRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<SettingsPage />} />
    </Routes>
  );
};
